/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FundViewModel } from './FundViewModel';
import {
    FundViewModelFromJSON,
    FundViewModelFromJSONTyped,
    FundViewModelToJSON,
} from './FundViewModel';

/**
 * 
 * @export
 * @interface FundsViewModel
 */
export interface FundsViewModel {
    /**
     * 
     * @type {Array<FundViewModel>}
     * @memberof FundsViewModel
     */
    funds: Array<FundViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof FundsViewModel
     */
    allowedToWriteJustBusiness: boolean;
}

/**
 * Check if a given object implements the FundsViewModel interface.
 */
export function instanceOfFundsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "funds" in value;
    isInstance = isInstance && "allowedToWriteJustBusiness" in value;

    return isInstance;
}

export function FundsViewModelFromJSON(json: any): FundsViewModel {
    return FundsViewModelFromJSONTyped(json, false);
}

export function FundsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'funds': ((json['Funds'] as Array<any>).map(FundViewModelFromJSON)),
        'allowedToWriteJustBusiness': json['AllowedToWriteJustBusiness'],
    };
}

export function FundsViewModelToJSON(value?: FundsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Funds': ((value.funds as Array<any>).map(FundViewModelToJSON)),
        'AllowedToWriteJustBusiness': value.allowedToWriteJustBusiness,
    };
}

